/*
  Two speech bubbles stepping up and to the right: a conversation that moves.
  Flat and two-shape on purpose — it stays legible down to a 16px favicon,
  where strokes and gradients turn to mud. The same artwork lives in
  public/icon.svg; change both together.
*/
export function LogoMark({ className = 'size-8' }: { className?: string }) {
  return (
    <svg viewBox="0 0 32 32" className={className} aria-hidden="true">
      <path
        d="M4 12h13a3 3 0 0 1 3 3v7a3 3 0 0 1-3 3h-6l-5 4v-4H4a3 3 0 0 1-3-3v-7a3 3 0 0 1 3-3z"
        fill="var(--tk-stage-1)"
      />
      <path
        d="M15 2h13a3 3 0 0 1 3 3v7a3 3 0 0 1-3 3h-2v4l-5-4h-6a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3z"
        fill="var(--tk-brand)"
      />
    </svg>
  )
}

export function Logo({ className }: { className?: string }) {
  return (
    <span className={`flex items-center gap-2.5 ${className ?? ''}`}>
      <LogoMark className="size-8 shrink-0" />
      <span className="text-[15px] font-semibold tracking-tight">
        sales <span className="text-brand">ai</span>
      </span>
    </span>
  )
}
